import { env } from '@src/config/env'
import axios from 'axios'

export const api = axios.create({
  baseURL: env.api.url,
})
